export type ToastContainerProps = {
  dataHook?: string;
  zIndex?: number;
  offset?: string | number;
  className?: string;
  children?: React.ReactElement | React.ReactElement[];
  position?: 'fixed' | 'absolute';
  /**
   * @default 1
   */
  maxToasts?: number;
};
